// extracted by mini-css-extract-plugin
export default {"linkMenuContainer":"m_bn","linkMenuContent":"m_bp"};